import styled from "styled-components";

export const ContainerDesktop = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: inherit;
    position: absolute;
    width: 100%;
    height: auto;
    top: 49px;
    left: 0;
    bottom: auto;
    background-color: ${(props) => props.theme.colors.brand4.pure};
    z-index: 1;
    overflow: hidden;
    max-height: 0px;
    transition: all 0.1ms;
    opacity: 0;
  }
`;

export const ContainerMobile = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  z-index: 2;
  background-color: ${(props) => props.theme.colors.brand4.dark};
  overflow: auto;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const Header = styled.header`
  padding: 40px 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors.neutral2.light};

  @media (min-width: 768px) {
    display: none;
  }
`;

export const Content = styled.main`
  flex: 1;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns:repeat(auto-fill, minmax(30%, 1fr) ) ; 
    gap: 5px 10px;
    justify-content: space-between;
    justify-items:center ;
    padding: 28px;
  }
`;
